import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { PillarPage } from '../components/marketing/PillarPage';
import {
  solutionsHospitalsConfig,
  solutionsHealthSystemsConfig,
  solutionsCaseManagersConfig,
  solutionsPostAcuteProvidersConfig,
} from '../components/marketing/solutionsConfigs';

const SOLUTIONS_BY_SEGMENT = {
  hospitals: solutionsHospitalsConfig,
  'health-systems': solutionsHealthSystemsConfig,
  'case-managers': solutionsCaseManagersConfig,
  'post-acute-providers': solutionsPostAcuteProvidersConfig,
};

/**
 * Solutions router page — /solutions/:segment.
 *
 * Consumes a config from `solutionsConfigs.js` based on the URL segment.
 * Unknown segments redirect to the platform overview so we never emit
 * a bare 404 for a curious visitor typing a solution URL.
 */
export default function SolutionsSegmentPage() {
  const { segment } = useParams();
  const config = SOLUTIONS_BY_SEGMENT[segment];
  if (!config) return <Navigate to="/post-acute-care-platform" replace />;
  return <PillarPage config={config} />;
}
